import LanguageFlag from './LanguageFlag';

export default LanguageFlag;
